import { DevicesOther } from '@mui/icons-material'

import { DevicesChart } from '@/components/charts/DevicesChart'
import type { BreakdownRow } from '@/apis/v2Mappers'

import { DimensionReport } from './DimensionReport'

const pie = (title: string) => (rows: BreakdownRow[]) => (
    <DevicesChart
        title={title}
        data={rows.slice(0, 8).map(r => ({ device: r.key, visitors: r.visitors }))}
    />
)

export function DevicesPage() {
    return (
        <DimensionReport
            title="Devices"
            emptyIcon={<DevicesOther />}
            emptyTitle="No device data yet"
            tabs={[
                { dim: 'device', label: 'Device type', chart: pie('Devices') },
                { dim: 'browser', label: 'Browser', chart: pie('Browsers') },
                { dim: 'os', label: 'Operating system', chart: pie('Operating systems') },
            ]}
        />
    )
}
